import { redirect } from '@tanstack/react-router';

import { getRuntimeConfig } from '@/lib/runtime-config.js';

/**
 * Route guard: if an admin has disabled the Quality section (runtime config
 * `features.quality === false`), redirect away from any `/quality*` route (covers
 * deep-links / bookmarks, not just the hidden nav entry). Fail-open — the config
 * loader defaults the flag to `true`, so a config blip leaves the route accessible.
 */
export function ensureQualityEnabled(): void {
  if (!getRuntimeConfig().features.quality) {
    throw redirect({ to: '/' });
  }
}
